export default __webpack_public_path__ + "locales/ru/Article.json?hash=579df1fff5961c00778d5207516dbb9d";